import React, { useState } from 'react';
import api from '../services/api';
import { ONBOARDING } from '../constants/strings';

export default function OnboardingModal({ onClose }) {
  const [saving, setSaving] = useState(false);

  async function handleClose() {
    setSaving(true);
    try {
      await api.confirmOnboarding();
    } catch {
      // Fail-silent: Modal trotzdem schließen, Zeitstempel wird beim nächsten Login nachgeholt
    } finally {
      setSaving(false);
      onClose();
    }
  }

  return (
    <div className="step-overlay-backdrop">
      <div className="step-overlay" style={{ maxWidth: 440, width: '90%', padding: '32px 28px' }}>
        <div style={{ fontSize: '2rem', marginBottom: 12 }}>🦉</div>
        <h2 style={{ fontFamily: 'var(--font-serif)', fontSize: '1.4rem', color: 'var(--txt)', marginBottom: 12 }}>
          {ONBOARDING.title}
        </h2>
        <p style={{ fontSize: '0.9rem', color: 'var(--txt2)', lineHeight: 1.6, marginBottom: 12 }}>
          {ONBOARDING.text}
        </p>
        <p style={{ fontSize: '0.85rem', color: 'var(--txt3)', lineHeight: 1.6, marginBottom: 24 }}>
          {ONBOARDING.textDisclaimer}
        </p>
        <button
          className="btn btn-primary"
          style={{ width: '100%' }}
          onClick={handleClose}
          disabled={saving}
        >
          {saving ? 'Wird gespeichert…' : ONBOARDING.btn}
        </button>
      </div>
    </div>
  );
}
